export default __webpack_public_path__ + "img/95aff59d3053a93aaff144255f4d4454.svg";